export default {
  hero: {
    title: "من که هستم؟",
    greeting: "سلام، فرانک هستم — توسعه‌دهنده فرانت‌اند و پژوهشگر یادگیری ماشین.",
    intro:
      "رابط‌های کاربری وب و موبایل طراحی و می‌سازم و در آزمایشگاه سیستم‌های انرژی تجدیدپذیر و کاربردهای نانوسیال در انتقال حرارت، روی یادگیری ماشین برای انرژی‌های تجدیدپذیر پژوهش می‌کنم — پژوهش‌های منتشرشده‌ای در به‌کارگیری یادگیری ماشین برای بهینه‌سازی سیستم‌های خورشیدی و ترموالکتریک. دوست دارم در نقطه تلاقی محصولات عرضه‌شده و پژوهش‌های داوری‌شده زندگی کنم.",
  },
  connect: {
    title: "با من در ارتباط باشید",
    subtitle: "بیایید در چیزی شگفت‌انگیز همکاری کنیم! از طریق هرکدام از این پلتفرم‌ها در تماس باشید.",
  },
  socialAriaLabel: "{{label}} فرانک",
  socialLabels: {
    email: "ایمیل",
    googleScholar: "گوگل اسکالر",
    website: "وب‌سایت",
    linkedin: "لینکدین",
    github: "گیت‌هاب",
    instagram: "اینستاگرام",
  },
};
